import React from 'react';
//import MainLogo from './../../../containers/UI/Common/MainLogo/MainLogo';
import Zigzag from '../../UI/Common/Shapes/Zigzag';
import Image from './../../../containers/UI/Image/Image';

//-- Assets
import kdLogo from './../../../assets/images/logo/logo_kidsmatin_mobile.svg';
import kdLogoWide from './../../../assets/images/logo/logo_kidsmatin_desk.svg';

const header = (props ) => {

    let logoAssetSrc = kdLogo;
    if(typeof props.hasWideLogo!=='undefined' && props.hasWideLogo==='true' ){
        logoAssetSrc = kdLogoWide;
    }

    return(
        <header className={[props.classes].join(' ')} >
            
            <div id="header-yellow-shape">
                <Zigzag color="#ffde39" translateXaxis="10" />
            </div>
            <Image id="hp-header-logo" imgPath={logoAssetSrc} imgName="kidsmatin-logo" action={props.onLogoClick} />
            { props.children }
        </header>
    );
}

export default header;


// WEBPACK FOOTER //
// ./src/containers/Navigation/Header/Header.js